const initialState = {
    catalogs: []
}
  
const general = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CATALOGS':
          return Object.assign({}, state, {
            catalogs: action.payload
          })
        case 'SET_CAMPAIGNS':
          return Object.assign({}, state, {
            campaigns: action.payload
          })
        default:
          return state
    }
}
    
    export default general